//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { AXIOS, axiosPost } from '../../axios/axios.js'
import LoginDialogComponent from './LoginDilogComponent.vue'
import LoginResetPassword from './LoginResetPassword.vue'
import { loadWurfl } from './wurfl.js'

export default {
  name: 'Login',
  components: {
    LoginDialogComponent,
    LoginResetPassword
  },
  data: function () {
    return {
      systemNameLabel: process.env.VUE_APP_SYSTEM_NAME_LABEL || null,

      userLogin: '',
      userPassword: '',
      loading: false,
      enterBtnText: 'Войти',
      publicSigningKey: null,
      dialog: false,
      blocked: false,
      message: null,
      loginType: null,
      loginTypes: [
        { imgSrc: '/delta/dist/img/delta-logo.svg', remember: false },
        { imgSrc: '/delta/dist/img/delta-logo-remember.svg', remember: true }
      ],
      showSnowflakes: false,
      arraySnowflakes: [],
      openedResetPassword: false,
      showWarningKicked: false,
      warningKicked: ''
    }
  },
  created: function () {
    this.showSnowflakes = this.showHappyNewYear()
    this.loginType = this.loginTypes[0]
    const countSnowflake = 15
    this.arraySnowflakes = [...Array(countSnowflake).keys()].map(x => ++x)
    this.getWarningKicked()
    loadWurfl(5000)
  },
  methods: {
    tryLogin: function () {
      this.loading = true
      this.putLoginToIndexedDB(this.userLogin)

      // Важно !!!
      // Для индикации процесса ожидания входа используется изменение текста,
      // а не динамическая иконка загрузки, поскольку загрузка иконки одновременно с запросом входа приводит к тому, что
      // сервер устанавливает Set-Cookie с JSESSIONID для обоих запросов, что может привести к блокировке дальнейшего
      // перехода на страницу диспетчера, если будет принят cookie запроса иконки
      //
      // Другой, более правильный вариант решения проблемы - загрузить все файлы страницы сразу.
      // Для этого нужно, чтобы webpack установил этим файлам <link rel=preload ...> в loginpage.html
      let loadingCounter = 0
      const timerId = setInterval(() => {
        if (!this.loading) {
          clearInterval(timerId)
          this.enterBtnText = 'Войти'
        } else {
          if (loadingCounter++ % 3 === 0) {
            this.enterBtnText = 'Вход'
          } else {
            this.enterBtnText = this.enterBtnText + '.'
          }
        }
      }, 100)

      // Удаление старого JSESSIONID
      document.cookie = 'JSESSIONID=;path=/;max-age=-1'

      const params = new URLSearchParams()
      params.append('j_username', this.userLogin)
      params.append('j_password', this.userPassword)

      if (this.loginType.remember) {
        params.append('remember-me', 'true')
      }

      this.blocked = false
      const th = this

      AXIOS.post('/j_spring_security_check', params, { withCredentials: true })
        .then(async function (response) {
          try {
            const wurfl = await loadWurfl(1000)
            await Promise.race([
              th.saveUserDevice(wurfl),
              new Promise(resolve => setTimeout(resolve, 1000))
            ])
          } catch (e) {
            console.warn('Не удалось сохранить данные устройства', e)
          }
          th.loading = false

          if (response.status === 200) {
            let redirectURLStr = response.request.responseURL
            const redirectURL = new URL(redirectURLStr)

            if (redirectURL.pathname === '/warning' || redirectURL.pathname === '/wait-login') {
              th.dialog = true
              th.message = redirectURL.searchParams.get('message')
            } else {
              localStorage.setItem('isSubscribed', 'false')
              localStorage.setItem('showActualizationFormLater', false)

              if (redirectURL.pathname === '/') {
                const origin = window.location.origin
                const prefix = origin + '/login?from='
                if (window.location.href.startsWith(prefix)) {
                  const fromEncoded = window.location.href.substring(prefix.length)
                  if (fromEncoded) {
                    redirectURLStr = origin + decodeURIComponent(fromEncoded)
                  }
                }
              }
              console.log('Redirect to: ' + redirectURLStr)
              th.clearWarningKicked()
              window.location.href = redirectURLStr
            }
          }
          return response
        })
        .catch(e => {
          this.loading = false
          console.error(e)
        })
    },
    saveUserDevice: function (wurfl = null) {
      if (wurfl) {
        const bodyFormData = new FormData()
        bodyFormData.set('props',
          JSON.stringify({
            deviceType: wurfl.complete_device_name,
            deviceName: wurfl.form_factor,
            mobile: wurfl.is_mobile,
            screenWidth: window && window.screen && window.screen.width,
            screenHeight: window && window.screen && window.screen.height,
            deviceMemory: navigator && navigator.deviceMemory || null
          })
        )

        return axiosPost({
          url: '/service/delta/user/logUserDevice',
          data: bodyFormData,
          onSuccess: response => response.data,
          onFailure: () => {
            return Promise.resolve()
          }
        })
      } else {
        return Promise.resolve()
      }
    },
    focusToPassword: function () {
      this.$refs.pwd.focus()
    },
    onAltS: function () {
      let index = this.loginTypes.indexOf(this.loginType)
      index = (index + 1) % this.loginTypes.length
      this.loginType = this.loginTypes[index]
    },
    putLoginToIndexedDB: function (userLogin) {
      const openRequest = indexedDB.open('db', 1)
      openRequest.onupgradeneeded = function (event) {
        const db = event.target.result
        if (!db.objectStoreNames.contains('login')) {
          db.createObjectStore('login', { keyPath: 'key' })
        }
      }
      openRequest.onsuccess = function (event) {
        const db = event.target.result
        const store = db.transaction('login', 'readwrite').objectStore('login')
        const request = store.put({ key: 'login', value: userLogin })

        request.onsuccess = function () {
          console.log('Логин добавлен в хранилище', request.result)
        }
        request.onerror = function () {
          console.log('Ошибка', request.error)
        }
      }
    },
    recoverPassword: function () {
      this.openedResetPassword = true
    },
    showHappyNewYear: function () {
      // 20.12 - 10.01
      const today = new Date()
      const todayYear = today.getFullYear()
      const dateFrom = new Date(todayYear + '/12/15')
      const dateStop = new Date(todayYear + '/01/10')
      const timeZoneOffset = today.getTimezoneOffset() * 60 * 1000
      const todayUTC = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0) + timeZoneOffset
      const dateFromUTC = Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate(), 0, 0, 0) + timeZoneOffset
      const dateStopUTC = Date.UTC(dateStop.getFullYear(), dateStop.getMonth(), dateStop.getDate(), 0, 0, 0) + timeZoneOffset
      return ((todayUTC >= dateFromUTC) || (todayUTC < dateStopUTC))
    },
    getWarningKicked: function () {
      this.showWarningKicked = localStorage.getItem('showWarningKicked') == 'false' ? false : localStorage.getItem('showWarningKicked')
      this.warningKicked = {
        main: localStorage.getItem('warningKickedMain'),
        ban: localStorage.getItem('warningKickedBan') == 'null' ? null : localStorage.getItem('warningKickedBan'),
        reason: localStorage.getItem('warningKickedReason')
      }
    },
    clearWarningKicked: function () {
      localStorage.setItem('showWarningKicked', false)
      localStorage.setItem('warningKickedMain', '')
      localStorage.setItem('warningKickedReason', '')
      localStorage.setItem('warningKickedBan', null)
    }
  }
}
